import { z } from 'zod';

export const GetTopicWordsResponseSchema = z.object({
  data: z.array(z.string().min(1, 'Word cannot be empty.')).max(300),
});

export type IGetTopicWordsResponseDto = z.infer<
  typeof GetTopicWordsResponseSchema
>;
